module.exports = __webpack_public_path__ + "static/media/me.56a24869.png";